// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2Dt1D","footer":"ChangeClinic_footer__2OxwL"};